import { useCallback, useState, type FormEvent } from 'react';
import { toast } from 'react-toastify';
import { RenameForm } from '~/components/dialogs/settings/RenameForm';
import { editOrganization } from '~/lib/.client/api/organizations';
import { userStore } from '~/lib/stores/user';
import type { OrganizationData } from '~/types/organization';
import { withSpinner } from '~/utils/withSpinner';

export const TeamName = ({ organization }: { organization: OrganizationData }) => {
  const [name, setName] = useState(organization.name);
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = useCallback((event: FormEvent<HTMLInputElement>) => {
    setName(event.currentTarget.value);
  }, []);

  async function handleSubmit(event: FormEvent) {
    event.preventDefault();
    event.stopPropagation();

    if (name === organization.name) {
      return;
    }

    await withSpinner({
      action: async () => {
        try {
          const orgData = await editOrganization({
            org: organization,
            data: {
              name,
            },
          });
          toast.success('Team name updated');
          userStore.setActiveOrganization(orgData);
        } catch (error) {
          if (error instanceof Error && error.message) {
            toast.error(error.message);
          }
        }
      },
      onStateUpdate: setIsLoading,
    });
  }

  const isDisabled = !name || name === organization.name;

  return (
    <RenameForm
      title="Team name"
      value={name}
      placeholder="Enter team name"
      handleChange={handleChange}
      handleSubmit={handleSubmit}
      isLoading={isLoading}
      isDisabled={isDisabled}
    />
  );
};
